/**
 * @voltxampere/ui — CP2102 USB-UART bridge variant (Sprint 49-6)
 *
 * Silicon Labs USB-to-UART converter (MSOP-10 / QFN-28). Common in
 * ESP modules, Pro Mini USB adapters, custom dev boards. No external
 * crystal required (internal 12 MHz oscillator).
 *
 * Reference: Silicon Labs CP2102/CP2109 datasheet (rev 1.7, 2018).
 *
 * Engine zero-diff invariant honored — schemaType `voltage-source`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const icCp2102 = {
    id: "cp2102",
    nameTr: "CP2102 (USB-UART Köprü)",
    nameEn: "CP2102 (USB-UART Bridge)",
    shortcut: "U",
    category: "active",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "CP2102",
    schemaType: "voltage-source",
    defaultParams: {
        voltage: 3.3,
        busType: "usb-uart",
        vendor: "Silicon Labs",
        package: "MSOP-10",
        maxBaudRate: 1_000_000,
        hasModemControl: true,
        voltageRangeV: { min: 3.0, max: 3.6 },
        crystalRequired: false,
    },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=ic-cp2102.js.map